import { Routes, Route, Navigate, Outlet } from 'react-router-dom';
import {
  ChartLineIcon,
  UserIcon,
  NavigatorItem,
  NavigatorLinkMenu,
} from '@forgeglobal/design-framework';

import AppLayout from '@tcs/client-portal-common/components/organisms/ApplicationLayout';
import SearchBar from '@tcs/client-portal-common/components/organisms/ApplicationLayout/SearchBar';
import Search from '@tcs/client-portal-common/components/templates/Search';
import SearchResults from '@tcs/client-portal-common/components/templates/SearchResults';
import Account from '@tcs/client-portal-admin/pages/Account';
import Application from '@tcs/client-portal-admin/pages/Application';
import Representative from '@tcs/client-portal-admin/pages/Representative';
import Profile from '@tcs/client-portal-admin/pages/Profile';
import useSession from '@tcs/client-portal-common/hooks/useSession';
import NotificationZone from '@tcs/client-portal-common/components/molecules/NotificationZone';
import useReportNotifications from '@tcs/client-portal-common/hooks/useReportNotifications';

const NAVIGATION_ITEMS: NavigatorItem[] = [
  {
    id: 'Accounts',
    icon: <ChartLineIcon />,
    to: '/accounts',
    exact: false,
  },
  {
    id: 'Profile',
    icon: <UserIcon />,
    to: '/profile',
    exact: false,
  },
];

const NAVIGATION_LINK_MENU: NavigatorLinkMenu = {
  title: 'I WANT TO...',
  navigatorLinkItems: [
    {
      id: 'Open a New Account',
      to: 'https://forgetrust.com/forms/open-a-new-account',
    },
    {
      id: 'Fund My Account',
      to: 'https://forgetrust.com/forms/fund-your-account',
    },
    {
      id: 'Make an Investment',
      to: 'https://forgetrust.com/forms/make-an-investment',
    },
    {
      id: 'Manage My Account',
      to: 'https://forgetrust.com/forms/manage-your-account',
    },
    {
      id: 'Disbursements and Distributions',
      to: 'https://forgetrust.com/forms/disbursements-and-distributions',
    },
  ],
};

const Layout = ({ clientPortalIdentity }) => {
  useReportNotifications();

  return (
    <AppLayout
      navigatorItems={NAVIGATION_ITEMS}
      navigatorLinkMenu={NAVIGATION_LINK_MENU}
      searchBar={
        <SearchBar savedItemsKey={clientPortalIdentity} type="admin" />
      }>
      {clientPortalIdentity && <NotificationZone />}
      <Outlet />
    </AppLayout>
  );
};

const Admin = () => {
  const {
    claims: { clientPortalIdentity },
  } = useSession();

  return (
    <Routes>
      <Route
        path="/"
        element={<Layout clientPortalIdentity={clientPortalIdentity} />}>
        <Route
          path="/"
          element={<Navigate state={{ from: '/' }} to="/accounts/" replace />}
        />
        <Route
          path="/asset_valuation"
          element={(() => {
            return (
              <Navigate
                state={{ from: '/asset_valuation' }}
                to="/accounts"
                replace
              />
            );
          })()}
        />
        <Route path="/accounts/:accountNumber/*" element={<Account />} />
        <Route path="/applications/:applicationId" element={<Application />} />
        <Route
          path="/accounts"
          element={<Search savedItemsKey={clientPortalIdentity} type="admin" />}
        />
        <Route
          path="/representatives/:representativeCode/*"
          element={<Representative />}
        />
        <Route path="/results" element={<SearchResults />} />
        <Route path="/profile/*" element={<Profile />} />
        <Route path="*" element={<Navigate state={{ from: '*' }} to="/" />} />
      </Route>
    </Routes>
  );
};

export default Admin;
